import React from "react";
import * as dc from "dc";
import * as d3 from 'd3';
import { ChartTemplate } from "./chartTemplate";

const barChartFunc = (divRef, ndx) => {
    let name = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
    const myChart = dc.barChart(divRef);
    let day;
    const dimension = ndx.dimension(function (d) {

         day = d.dsubmissiom.getDate();
        // if(year < 2009) {
        //   year = 2018;
        // } else year = 2019;
        //console.log(month);

        return day;
        //name = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    });
    const group = dimension.group().reduce(
     function(p, v) { // add
       ++p.count;
       if(p.count > 0) {
         p.totalWords += v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary += v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] += 1
         }
         else{
             p.p_ids[v.project_id] = 1;
             p.id_count++;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
       }
       return p;
     },
     function(p, v) { // remove
       --p.count;
       if(p.count > 0) {
         p.totalWords -= v.n_of_words;
         p.avgWords = Math.floor(parseFloat(100*p.totalWords/p.count))/100;
         p.totalVocabulary -= v.vocabulary_used;
         p.avgVocabulary = Math.floor(parseFloat(100*p.totalVocabulary/p.count))/100;
         if(v.project_id in p.p_ids){
           p.p_ids[v.project_id] -= 1
         }
         if(p.p_ids[v.project_id] === 0){
             delete p.p_ids[v.project_id];
             p.id_count--;
         }
       }
       else {
         p.avgWords = 0;
         p.totalWords = 0;
         p.totalVocabulary = 0;
         p.avgVocabulary = 0;
         p.id_count = 0;
         p.p_ids = {};
       }
       return p;
     },
     function() { // init
         return {count: 0, totalWords: 0, avgWords: 0, totalVocabulary: 0, avgVocabulary: 0, id_count: 0, p_ids: {}};
     }
   );

    myChart
    .dimension(dimension)
    .group(group)
    .valueAccessor(function (p) {
       return p.value.count ;
     })
    .x(d3.scaleOrdinal().domain(day))
    //.x(d3.scaleLinear().domain([1, 31]))
    .xUnits(dc.units.ordinal)
    //.brushOn(true)
    .elasticY(true)
    .height(142)
    .barPadding(0.1)
    .outerPadding(0.05)
    .round(dc.round.floor)
    .margins({ top: 5, right: 15, bottom: 25, left: 50 })
    .colors(["#065FE5"])
    //.renderLabel(true)
    //.label(function(d) {return Math.floor(d.count ) })
    //.xAxis().tickValues([1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31])
    //.yAxis().tickFormat(d3.format('s')).ticks(6)
    //.labelOffsetX(-50)
    //.yAxisPadding('50');
    myChart.yAxis().ticks(4)

    return myChart
}

export const BarChartDay = props => (
  <ChartTemplate chartFunction={barChartFunc} title={props.title} metric={props.metric}
    showMetricsSelector={props.showMetricsSelector}/>
)
